import React, { RefObject } from "react";
import { useClickAway } from "react-use";
import { POPOVER_CONTAINER_CLASS } from "../design-system/components";
import {
  MODAL_CONTAINER_CLASS,
  DIALOG_CONTAINER_CLASS,
} from "../design-system/dialogs";
import { showDialog } from "../design-system/dialogs/ConfirmationDialog/ConfirmationDialog";

export interface UseNavigationProtectionOptions {
  containerRef: RefObject<HTMLElement>;
  warningMessage: string;
  alertTitle?: string;
  onCancel?: () => void;
  isActive?: boolean;
}

const showNavigationWarning = (
  warningMessage: string,
  onCancel?: () => void,
  href?: string,
  alertTitle?: string
) => {
  showDialog({
    title: alertTitle || "Unsaved changes",
    message: <div className="modal-text">{warningMessage}</div>,
    buttons: [
      {
        "data-testid": "cancel-exit",
        label: "Stay",
      },
      {
        buttonStyle: "danger",
        label: "Leave",
        onClick: () => {
          onCancel?.();
          if (href) {
            window.location.href = href;
          }
        },
      },
    ],
  });
};

export const useNavigationProtection = ({
  containerRef,
  warningMessage,
  onCancel,
  isActive = true,
  alertTitle,
}: UseNavigationProtectionOptions) => {
  useClickAway(containerRef, (e: MouseEvent) => {
    if (!isActive) {
      return;
    }

    const clickedElement = e.target;
    if (!(clickedElement instanceof HTMLElement)) {
      return;
    }

    if (
      clickedElement.closest(`.${POPOVER_CONTAINER_CLASS}`) ||
      clickedElement.closest(`.${MODAL_CONTAINER_CLASS}`) ||
      clickedElement.closest(`.${DIALOG_CONTAINER_CLASS}`)
    ) {
      return;
    }

    const anchorElement = clickedElement.closest("a");
    if (anchorElement) {
      if (anchorElement.target === "_blank") {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      showNavigationWarning(
        warningMessage,
        onCancel,
        anchorElement.href,
        alertTitle
      );
    }
  });
};
